import styled from 'styled-components/macro';
import { Download, Scrollbar } from '~/components';

export const Container = styled.div`
  display: flex;
  height: 100%;
  /*
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    height: auto;
    flex-direction: column;
  }
  */
`;

export const ContainerSm = styled.div`
  display: flex;
  flex-direction: column;

  & table {
    thead {
      background-color: ${({ theme }) => theme.white};
      tr {
        height: 60px;
        background-color: ${({ theme }) => theme.white};
        th {
          min-width: 45px;
          background-color: ${({ theme }) => theme.white};
          top: 0px;
          position: sticky;
          padding: 35px 0;
          div {
            text-align: left;
          }
          &:first-child {
            opacity: 1;
            div {
              color: ${({ theme }) => theme.white};
            }
          }
        }
      }
    }
  }
`;

export const ContainerTeam = styled.div`
  display: flex;
  flex-direction: column;
  width: 516px;
  height: 100%;
`;

export const Scroller = styled(Scrollbar)``;

export const DownloadPDFButton = styled(Download)`
  position: fixed;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
`;

export const ContainerArbitration = styled.div`
  flex-grow: 1;
  height: 100%;
`;
